import { Chip } from "@mui/material";
import React from "react";
import theme from "../../../theme/Theme";

const assignedStyle = {
  color: theme.palette.artisticSuccess500.main,
  backgroundColor: theme.palette.artisticTagsGreen50.main,
};

const unAssignedStyle = {
  color: theme.palette.artisticWarning500.main,
  backgroundColor: theme.palette.artisticWarning300.main,
};

export const StatusChip = (params) => {
  const label = params.data?.worker_status;

  return (
    <Chip
      style={{ height: "18px", fontSize: "11.67px", lineHeight: "14p" }}
      label={label}
      sx={label?.toLowerCase() === "assigned" ? assignedStyle : unAssignedStyle}
    />
  );
};
